import Dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

Dayjs.extend(utc);
Dayjs.extend(timezone);
Dayjs.tz.setDefault(Dayjs.tz.guess());

export const dayJsToLocalTime = (date: string, format = 'h:mm a') => {
  const utcTime = Dayjs.utc(date, 'YYYY-MM-DD HH:mm:ss');
  const local = Dayjs(utcTime).tz(Dayjs.tz.guess());
  return local.format(format);
};

export const userTimezone: string = Dayjs.tz.guess();
